import { Event } from '@/event-bus/event';

export class MassEditHideWarningMultipleStatusesEvent extends Event<void> {}
